import React from "react";
import { FilterBar } from "components/ui";
import { TopicsFilterProps } from "./types";
import styles from "./styles.module.scss";

export const TopicsFilter: React.FC<TopicsFilterProps> = ({
  topics,
  activeFilter,
  handleFilterChange,
  activeTab,
}) => {
  const onFilterChange = (filter: string) => {
    handleFilterChange && handleFilterChange("topics", filter);
  };

  return (
    <div className={styles.searchAndFilterContainer}>
      {handleFilterChange && (
        <FilterBar
          options={topics?.options || []}
          activeFilters={activeFilter || []}
          onFilterChange={onFilterChange}
          className={styles.filterBar}
          libraryType={activeTab}
        />
      )}
    </div>
  );
};
